import React, { useState, useEffect, useRef } from "react";
import { useDispatch, connect } from "react-redux";
import {
  Form,
  Button,
  Spinner,
  Col,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import Error from "../../Layout/Error";
import { format } from "date-fns";
import {
  updateDataOnRequest,
  getDataOnRequest,
} from "../../../redux/actions/CommonActions";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Label from "../../Layout/Label";
import Textarea from "../../FormElements/Textarea";
import Input from "../../FormElements/Input";
import Dropdown from "../../FormElements/Dropdown";
import { printSkeleton } from "../../../services/GlobalSkeleton";
import swipeInOrOutAudio from "../../Layout/swipeinorout.mp3";
import {
  concateAddress,
  convertToOriginalForm,
} from "../../../services/StringOperation";
import PendingSwipeInOrOutAssignments from "./PendingSwipeInOrOutAssignments";
import useAudioPermission from "../../../services/GlobalPlayAudioFunctions";

const SwipeInModal = ({
  curretAssinmentIndividualData,
  showSwipeInModal,
  setShowSwipeInModal,
  deviceInfo,
}) => {
  const { requestPermissionAndPlay } = useAudioPermission(swipeInOrOutAudio);
  const [showAudio, setShowAudio] = useState(false);

  useEffect(() => {
    if (showAudio == false) {
      const timer = setTimeout(() => {
        requestPermissionAndPlay();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showAudio]);

  return (
    <React.Fragment>
      <Modal
        show={showSwipeInModal}
        onHide={() => setShowSwipeInModal(false)} // Close modal and update parent state
        className="col-sm-12 fade"
        size="lg"
        style={{ borderRadius: "25px" }}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-header bg-dark text-white">
          <h4 className="" id="ResumeheadlineModalLongTitle">
            Pending Swipe In/Out Assignments
          </h4>
          <a
            className="btn btn-danger btn-sm text-white m-2 cursor-pointer"
            onClick={() => setShowSwipeInModal(false)} // Close modal on click
          >
            <b>
              <i className="fa fa-close"></i>
            </b>
          </a>
        </div>
        <div
          className="modal-body custom-scrollbar"
          style={{
            maxHeight: "80vh",
            overflowY: "auto",
            padding: "15px",
          }}
        >
          <form className="attach-resume">
            {/* <pre>{JSON.stringify(curretAssinmentIndividualData, null, 2)}</pre> */}
            <PendingSwipeInOrOutAssignments
              curretAssinmentIndividualData={curretAssinmentIndividualData}
              setShowSwipeInModal={setShowSwipeInModal}
              deviceInfo={deviceInfo}
            />
          </form>
        </div>
      </Modal>
      <style>
        {`
  /* Custom Scrollbar */
  .custom-scrollbar::-webkit-scrollbar {
    width: 8px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f0f8ff; /* Light Blue */
    border-radius: 10px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #007bff; /* Blue */
    border-radius: 10px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #0056b3; /* Darker Blue */
  }
  `}
      </style>
    </React.Fragment>
  );
};

export default SwipeInModal;
